import { useTheme } from '@mui/material'

type PandaIconProps = {
  size?: number
  bgColor?: string
  fgColor?: string // <- color of the "pd"
  disabled?: boolean
}

const PandaIconSvg = ({ size = 45, bgColor, fgColor, disabled = false }: PandaIconProps) => {
  const theme = useTheme()
  const bg = bgColor ?? 'rgb(242,180,45)'
  const fg = fgColor ?? theme.palette.common.white

  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 80 80"
      width={size}
      height={size}
      aria-hidden
      style={{ display: 'block', opacity: disabled ? 0.5 : 1, borderRadius: '100px' }}
    >
      {/* circular background */}
      <circle cx="40" cy="40" r="40" fill={bg} />

      {/* the "pd" mark */}
      <rect id="XMLID_616_" width="80" height="80" fill={bgColor ?? theme.palette.text.disabled}></rect>
      <path
        d="M58.5,17.7v11.8l-0.2,0.1c-1.7-1.4-3.9-2.3-6.7-2.3c-3.6,0-6.9,1.3-9.1,3.9l3.4,3.6
           c1.7-1.6,3.5-2.5,5.8-2.5c4.3,0.1,7.1,3.4,7.1,7.8c0,4.4-2.9,7.8-7.3,7.8c-11,0-7.9-20.6-22.7-20.6c-7.4,0-12.6,5.5-12.6,12.8
           v22.3h5.3V50.5l0.2-0.1c1.7,1.4,3.9,2.3,6.7,2.3c3.6,0,6.9-1.3,9.1-3.9l-3.4-3.6c-1.7,1.6-3.5,2.5-5.8,2.5
           c-4.3-0.1-7.1-3.4-7.1-7.8c0-4.4,2.9-7.8,7.3-7.8c11,0,7.9,20.6,22.7,20.6c7.4,0,12.6-5.5,12.6-12.8V17.7H58.5z"
        fill={fg} // <- directly control glyph color
      />
    </svg>
  )
}

export default PandaIconSvg
